import { AppliedCoupon, AssignedCoupon } from '@app/types/cart/Coupon';
import { Box, Button, Card, constants, Text } from '@redbubble/design-system';
import { defineMessages, useIntl } from '@redbubble/next/intl';
import { FC } from 'react';
import { useDateRangeMessage } from '../../Coupon/useDateRangeMessage';
import styles from './CouponItem.module.scss';

export interface CouponItemProps {
  locale: string;
  coupon: AssignedCoupon;
  appliedCoupon?: AppliedCoupon;
  loading?: boolean;
  onAction: (coupon: AssignedCoupon, isApply: boolean) => any;
  testId?: string;
}

export const messages = defineMessages({
  apply: {
    defaultMessage: 'Apply',
  },
  remove: {
    defaultMessage: 'Remove',
  },
});

export const CouponItem: FC<CouponItemProps> = ({
  locale,
  coupon,
  appliedCoupon,
  loading = false,
  onAction,
  testId,
}) => {
  const intl = useIntl();
  const isAssignedCouponNotCurrentAppliedCoupon =
    coupon.code !== appliedCoupon?.code;
  const showApplyButtonText =
    !appliedCoupon || isAssignedCouponNotCurrentAppliedCoupon;
  const { display_name, expiry_date, code } = coupon;
  const dateRange: [Date, Date] = [new Date(), new Date(expiry_date)];
  const expiryDateRangeMessage = useDateRangeMessage(locale, ...dateRange);

  return (
    <Card data-testid={testId}>
      <Box
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        className={
          showApplyButtonText
            ? styles.neutralBackground
            : styles.removeBackground
        }
      >
        <Box padding="s" flexDirection="column" justifyContent="space-between">
          <Text display="block" type="caption" marginBottom="xxs">
            {expiryDateRangeMessage}
          </Text>
          <Text display="block" type="body2">
            <strong>{display_name}</strong>
          </Text>
          <Text display="block" type="body2">
            {code}
          </Text>
        </Box>
        <Box
          padding="s"
          display="flex"
          flexDirection="column"
          justifyContent="flex-end"
        >
          <Button
            type="button"
            size={constants.MEDIUM}
            intent={
              showApplyButtonText ? constants.NEUTRAL : constants.EXPRESSIVE
            }
            fluid
            strong
            disabled={loading}
            loading={loading}
            onClick={() => onAction(coupon, showApplyButtonText)}
          >
            {showApplyButtonText
              ? intl.formatMessage(messages.apply)
              : intl.formatMessage(messages.remove)}
          </Button>
        </Box>
      </Box>
    </Card>
  );
};
